import { useState } from 'react';

export const usePdfDownload = () => {
    const [isGenerating, setIsGenerating] = useState(false);

    const downloadPdf = async (htmlContent: string, filename: string, customStyles?: string) => {
        if (!htmlContent || isGenerating) return;

        setIsGenerating(true);
        try {
            const iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = 'none';
            document.body.appendChild(iframe);

            const htmlDoc = `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Test</title>
                    <style>
                        @page {
                            size: A4;
                            margin: 10mm;
                        }
                        
                        @media print {
                            @page { 
                                margin: 10mm;
                            }
                            html, body {
                                margin: 0 !important;
                                padding: 0 !important;
                            }
                        }

                        body {
                            font-family: Arial, sans-serif;
                            font-size: 11px;
                            line-height: 1.5;
                            color: #000;
                            padding: 20px;
                            max-width: 750px;
                            margin: 0 auto;
                        }

                        h1, h2, h3, h4, h5, h6 {
                            color: #000;
                            margin-top: 16px;
                            margin-bottom: 8px;
                            font-weight: bold;
                            page-break-after: avoid;
                        }

                        h1 { font-size: 18px; }
                        h2 { font-size: 16px; }
                        h3 { font-size: 14px; }
                        h4, h5, h6 { font-size: 12px; }

                        p {
                            margin: 8px 0;
                            page-break-inside: avoid;
                        }

                        ul, ol {
                            margin: 8px 0;
                            padding-left: 20px;
                        }

                        li {
                            margin: 4px 0;
                            page-break-inside: avoid;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 8px 0;
                        }

                        th, td {
                            text-align: left;
                        }

                        .maintable th, .maintable td {
                            border: 1px solid #ddd;
                            padding: 6px;
                        }

                        th {
                            background-color: #f5f5f5;
                            font-weight: bold;
                        }

                        strong, b {
                            font-weight: bold;
                        }

                        em, i {
                            font-style: italic;
                        }

                        a {
                            color: #0066cc;
                            text-decoration: underline;
                        }

                        @media print {
                            body {
                                padding: 0;
                            }
                        }
                    ${customStyles || ''}
                    </style>
                </head>
                <body>${htmlContent}</body>
                </html>
            `;

            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (iframeDoc) {
                iframeDoc.open();
                iframeDoc.write(htmlDoc);
                iframeDoc.close();

                iframeDoc.title = filename;
                const originalTitle = document.title;
                document.title = filename;

                setTimeout(() => {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();

                    setTimeout(() => {
                        document.title = originalTitle;
                        document.body.removeChild(iframe);
                    }, 1000);
                }, 100);
            }
        } catch (error) {
            console.error('Error opening print dialog:', error);
        } finally {
            setIsGenerating(false);
        }
    };

    return {
        downloadPdf,
        isGenerating,
    };
};
